import { useEffect } from "react";
import { logoutSession } from "../services/sessionLogout";
export var DEFAULT_IDLE_TIMEOUT_MINUTES = 60;
var ACTIVITY_EVENTS = ["mousemove", "keydown"];
export function getIdleTimeoutMs(rawMinutes) {
    if (rawMinutes === void 0) { rawMinutes = process.env.REACT_APP_IDLE_TIMEOUT_MINUTES; }
    var minutes = Number(rawMinutes);
    var effective = Number.isFinite(minutes) && minutes > 0
        ? minutes
        : DEFAULT_IDLE_TIMEOUT_MINUTES;
    return effective * 60 * 1000;
}
/**
 * Ends the session through the shared logout after `timeoutMs` without mouse or
 * keyboard activity. Disabled while there is no authenticated session.
 */
export function useIdleLogout(enabled, timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = getIdleTimeoutMs(); }
    useEffect(function () {
        if (!enabled)
            return undefined;
        var timer;
        var start = function () {
            timer = setTimeout(function () {
                console.log("[useIdleLogout] Idle timeout reached:", { timeoutMs: timeoutMs });
                void logoutSession({ reason: "idle" });
            }, timeoutMs);
        };
        var reset = function () {
            clearTimeout(timer);
            start();
        };
        start();
        ACTIVITY_EVENTS.forEach(function (evt) { return window.addEventListener(evt, reset); });
        return function () {
            clearTimeout(timer);
            ACTIVITY_EVENTS.forEach(function (evt) { return window.removeEventListener(evt, reset); });
        };
    }, [enabled, timeoutMs]);
}
